import { useState, useEffect } from "react"

export const useCachedState = (cacheKey, initialState) => {
    const [state, setState] = useState(() => {
        try {
            const cachedValue = sessionStorage.getItem(cacheKey)
            return cachedValue !== null ? JSON.parse(cachedValue) : initialState
        } catch (error) {
            return initialState
        }
    })

    useEffect(() => {
        sessionStorage.setItem(cacheKey, JSON.stringify(state))
    }, [cacheKey, state])

    return [state, setState]
}
